import { API_URL } from "config";
import Http from "util/https";
import { SupplierResponseApi, SupplierSearchApiParams, SupplierStockList } from "../types/index";
import { convertUTCToDate, nullToZero } from "../utils/common";
import { supplierStockApiResponse } from "./apiConstants";


/**
 * 仕入先・外部倉庫用在庫一覧Api(商品管理部用在庫一覧Apiと同じ)
 * @param params 在庫一覧Apiのパラメータ
 * @returns SupplierStockList
 */
export default async function supplierStockListApi(params: SupplierSearchApiParams) {
  console.log('supplierStockList:', params);

  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/select/supplier`;
  const res = await http.post<SupplierResponseApi>(url, params);

  // const res: {data: SupplierResponseApi} = {
  //   data: supplierStockApiResponse
  // }

  const stockList: SupplierStockList = {
    total: res.data.total,
    stocks: res.data.stocks.map((s, i) => ({
      id: `${i + (params.offset ?? 0)}`,
      JANCd: s.jan_cd,
      productNumber: s.item_num,
      productName: s.item_name,
      brand: s.brand_name,
      productCd: s.item_code,
      size: s.size,
      classification: s.class_name,
      symbolThresholdList: s.threshold_max && s.threshold_min ? [s.threshold_max, s.threshold_min] : undefined,
      amountSymbol: "×",
      amountCount: nullToZero(s.total_quantity),
      supplierWarehouses: s.depot_stocks.filter(ds => ds.depot_cd != null).map(ds => ({ // depot_cdがnullでもセンター倉庫ではquantityが入ることがあるが、無視することとした。
        code: ds.depot_cd ?? "",
        name: ds.depot_name ?? "",
        amount: nullToZero(ds.quantity),
        isCenter: !ds.depot_kind,
      })),
      arrivalDate: convertUTCToDate(s.arrival_date),
      stockVisibleType: s.display_mode ?? 2,
      isDiscontinued: !!s.discontinued_flag
    })),
  }

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res);
  // return res.data;
  return stockList;
}
